module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h6', [_vm._v("待補藥清單")]), _vm._v(" "), _c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/refill-order/?drug_storage__device__net__system__type=Tag"),
      "data-path": "",
      "pagination-path": "",
      "fields": _vm.fields,
      "api-mode": true,
      "css": _vm.boostrapCss,
      "http-options": _vm.httpOptions
    },
    on: {
      "vuetable:cell-clicked": _vm.onCellClicked
    },
    scopedSlots: _vm._u([{
      key: "num-refill",
      fn: function(props) {
        return [_c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(props.rowData.drug_storage.max_stock - props.rowData.drug_storage.stock))])]
      }
    }, {
      key: "action",
      fn: function(props) {
        return [_c('button', {
          staticClass: "btn btn-danger",
          on: {
            "click": function($event) {
              return _vm.deleteOrder(props.rowData.id)
            }
          }
        }, [_vm._v("刪除")])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3835bceb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/TagManagement/PlanningList.vue
// module id = 1432
// module chunks = 1